module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_manage_employee_questions.644f1ebc.svg";